import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Table, Data } from 'components/layout/Table'
import { getOrganizations } from 'utils/token'
import { Title } from 'components/layout'
import { Button } from 'components/misc'
import { organizations as organizationsLayout } from 'constants/layout'
import styles from './organization-switcher.styl'
import { ROLES } from 'constants/enums'
import _ from 'lodash'

export default class OrganizationSwitcher extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
    isFromLogin: PropTypes.bool,
    isGOPEnabled: PropTypes.bool.isRequired
  }

  render() {
    const { user, isFromLogin, isGOPEnabled } = this.props

    let organizations = getOrganizations(user) || {}

    const organizationKeys = Object.keys(organizations).sort()

    let filterOrganizationKeys = organizationKeys.filter(
      item => item !== ROLES.ASSESSOR.u
    )

    if (!isGOPEnabled) {
      organizations = _.omit(organizations, 'gop_staff')
      filterOrganizationKeys = filterOrganizationKeys.filter(
          item => item !== ROLES.GOP_STAFF.u
      )
    }

    return (
      <div className={`${styles.switcher}`}>
        <Title h2 intl="moduleTitle.select_role_organization">
          Select role and organisation
        </Title>

        <Table ths={organizationsLayout.tableHeadersOrganizationSwitcher}>
          <Data>
            {filterOrganizationKeys.map(key =>
                organizations[key].organizations.map((item, y) => (
                <tr key={y}>
                  <td>
                    <FormattedMessage
                      id={`roles.${key}`}
                      defaultMessage={key}
                    />
                  </td>
                  <td>{item.name}</td>
                  <td>
                    <Button
                      intlKey="button.select"
                      onClick={() =>
                        this.props.onSelect({
                          name: item.name,
                          id: item.id,
                          regionId: item.regionId,
                          hierarchyLevelType: item.hierarchyLevelType,
                          userType: key
                        })}
                    >
                      Select
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </Data>
        </Table>
        {isFromLogin && (
          <FormattedMessage
            tagName="span"
            id="label.switch_organisation_hint"
            defaultMessage="You can open this dialog anytime by choosing 'Switch Organisation' in the upper-right corner menu"
          />
        )}
      </div>
    )
  }
}
